import React from 'react'

import Translator from 'bazinga-translator'
import { useUser } from 'containers/MainLayout/selectors'

import Btn from '../../../../Btn'
import PlayForFunButton from '../Play/PlayForFunButton'
import { ButtonsWrapper } from './styles/ButtonsWrapper'
import { getURLForLoggedOutPlayForReal } from './utils'

interface Props {
  realPlayUrl: string
  forFunPlayUrl: string
  small?: boolean
}

function LoggedOutButtons({ realPlayUrl, forFunPlayUrl, small }: Props) {
  const user = useUser()

  const isPlayForFunPermitted = !!user?.isPlayForFunPermitted
  const url = getURLForLoggedOutPlayForReal(!!user?.isLoginAndPlayPossible, realPlayUrl)

  return (
    <ButtonsWrapper>
      <Btn
        xl={!small}
        svg
        primary
        to={url}
      >
        {Translator.trans('login and play', {}, 'games')}
      </Btn>
      <PlayForFunButton
        forFunPlayUrl={forFunPlayUrl}
        condition={isPlayForFunPermitted}
      />
    </ButtonsWrapper>
  )
}

export default LoggedOutButtons
